import React from 'react';
import './global-table-filter.styles.scss';

function GlobalTableFilter({ filter, setFilter }) {
  return (
    <div className='global-filter-container'>
      <label className='global-filter-title'>Search: </label>
      <input
        title='Global filter'
        className='global-filter-input'
        value={filter || ''}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
}

export default GlobalTableFilter;
